import { render, staticRenderFns } from "./ImportantInfo.vue?vue&type=template&id=784b5f1e"
import script from "./ImportantInfo.vue?vue&type=script&lang=js"
export * from "./ImportantInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('784b5f1e')) {
      api.createRecord('784b5f1e', component.options)
    } else {
      api.reload('784b5f1e', component.options)
    }
    module.hot.accept("./ImportantInfo.vue?vue&type=template&id=784b5f1e", function () {
      api.rerender('784b5f1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/preview/ImportantInfo.vue"
export default component.exports